<template>
  <div class="form-wrapper">
    <form-section
      :description="sectionDescription"
      :title="sectionTitle"
      class="file-upload-section"
    >
      <file-upload
        :error="$_formMixin_getHasError('files')"
        :error-msg="$_formMixin_getErrorMsg('files')"
        :files="files"
        :force-accept="true"
        :old-files="oldFiles"
        :max-files="maxFiles"
        accept="image/*, .pdf, .doc, .docx"
        button-type="btn-blue"
        class="field-group"
        @addFiles="addFiles"
        @removeAll="removeAllFiles"
        @removeFailedFile="removeFailedFile"
        @removeFile="removeFile"
      />
    </form-section>
  </div>
</template>

<script>
  import FormMixin from 'components/Forms/FormMixin'
  import AbstractStore from 'store/AbstractStore'

  export default {
    extends: AbstractStore,
    components: {
      'form-section': () => import(
        /* webpackChunkName: "form-section-layout" */ 'components/Forms/FormSection'),
      'file-upload': () =>
        import(/* webpackChunkName: "file-upload" */ 'components/Forms/FileUpload')
    },
    mixins: [FormMixin],
    props: {
      sectionTitle: {
        type: String,
        default: ''
      },
      sectionDescription: {
        type: String,
        default: ''
      },
      namespace: {
        type: String,
        required: true
      },
      maxFiles: {
        type: Number,
        default: 3
      }
    },
    computed: {
      files () {
        return this.deepStore().files
      },
      oldFiles () {
        return this.deepStore().oldFiles
      },
      formErrors () {
        return this.deepStore().formErrors
      },
      validation () {
        return this.abstractGetter('/validation')
      }
    },
    methods: {
      addFiles(files) {
        this.$store.commit(this.namespace + '/addFiles', files)
        this.$store.dispatch(this.namespace + '/touchFiles')
      },

      removeFile(index) {
        this.$store.commit(this.namespace + '/removeFile', index)
      },

      removeFailedFile(index) {
        this.$store.commit(this.namespace + '/removeFailedFile', index)
      },

      removeAllFiles() {
        this.$store.commit(this.namespace + '/removeAllFiles')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .form-wrapper {
    background: $formBlock;
  }

  .file-upload-section {
    ::v-deep .file-upload {
      &.error {
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;

        @include bp-mf-tablet {
          align-items: flex-end;
        }
      }
    }
  }
</style>
